import { MarketCountryCode } from '@backmarket/http-api'

export const COUNTRIES_WITHOUT_YOU_SAVE = [MarketCountryCode.JP]

export const COUNTRIES_WITHOUT_STRIKED_PRICE_NEW_LABEL = [MarketCountryCode.JP]

export const COUNTRIES_WITH_REBURBISHED_PRICE_LABEL = [MarketCountryCode.JP]

export const COUNTRIES_WITH_VAT_PRICE_LABEL = [MarketCountryCode.JP]

export const COUNTRIES_WITH_TRADE_IN_PRICE_LABEL = [
  MarketCountryCode.US,
  MarketCountryCode.GB,
  MarketCountryCode.FR,
  MarketCountryCode.DE,
  MarketCountryCode.ES,
]
